(function () {
  'use strict';

  var BAR_ID = 'wb-inline-floating-summary';
  var POLL_MS = 450;
  var BOTTOM_OFFSET_CSS = '16px';

  function getBar() {
    return document.getElementById(BAR_ID);
  }

  function getBookingRoot() {
    return document.querySelector('.pdp-workshop-booking');
  }

  function getPanel() {
    return document.querySelector('[data-wb-panel], [data-ai-wb-sticky]');
  }

  function getVenueCardPanel() {
    var root = getBookingRoot();
    return root ? root.querySelector('[data-events-panel="1"], .wb-venue-card, .workshop-venue-card') : null;
  }

  function getFooter() {
    return document.querySelector('footer, #shopify-section-footer, .site-footer');
  }

  function getBookingBox() {
    var root = getBookingRoot();
    return root ? root.querySelector('[data-workshop-booking]') : null;
  }

  function getVariantImageUrl(variantId) {
    var jsonEl = document.querySelector('[data-variant-json]');
    if (!jsonEl) return '';
    var raw = (jsonEl.tagName === 'TEXTAREA') ? jsonEl.value : (jsonEl.textContent || '').trim();
    if (!raw) return '';
    var variants;
    try {
      variants = JSON.parse(raw);
    } catch (e) {
      return '';
    }
    if (!Array.isArray(variants) || variants.length === 0) return '';
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (String(v.id) !== String(variantId)) continue;
      if (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) {
        return v.featured_media.preview_image.src;
      }
      if (v.featured_media && v.featured_media.src) return v.featured_media.src;
      if (v.featured_image && v.featured_image.src) return v.featured_image.src;
      return '';
    }
    return '';
  }

  function formatDateForBar(dateKey) {
    if (!dateKey || typeof dateKey !== 'string') return '';
    var parts = dateKey.trim().split('-');
    if (parts.length < 3) return dateKey.trim();
    var y = parts[0];
    var m = parseInt(parts[1], 10);
    var d = parseInt(parts[2], 10);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var mon = months[m - 1] || parts[1];
    return (d + ' ' + mon);
  }

  function isWeekdayOnly(str) {
    if (!str || typeof str !== 'string') return false;
    var s = str.trim();
    var weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return weekdays.indexOf(s) !== -1 || weekdays.some(function (w) { return s.indexOf(w) === 0; });
  }

  function readSelection() {
    var booking = getBookingRoot();
    if (!booking) return null;

    var card = booking.querySelector('.workshop-event-card.is-selected');
    var variantBtn = booking.querySelector('.wb-variant-btn.is-active');
    if (!card || !variantBtn) return null;

    var venueEl = booking.querySelector('[data-selected-event-venue]');
    var venue = (venueEl && venueEl.textContent) ? venueEl.textContent.trim() : '';
    if (!venue && card) {
      venue = (card.dataset.venueName || card.dataset.city || '').trim();
    }
    var dateKey = (card.dataset.dateKey || '').trim();
    var dateLabel = (card.dataset.dateLabel || '').trim();
    var timeLabel = (card.dataset.timeLabel || '').trim();
    var datetimeEl = booking.querySelector('[data-selected-event-datetime]');
    var datetimeStr = (datetimeEl && datetimeEl.textContent) ? datetimeEl.textContent.trim() : '';
    if ((!dateLabel || !timeLabel) && datetimeStr) {
      var parts = datetimeStr.split(/\s+/);
      if (parts.length >= 2) {
        if (!dateLabel) dateLabel = parts[0];
        if (!timeLabel) timeLabel = parts.slice(1).join(' ');
      } else if (!dateLabel) {
        dateLabel = datetimeStr;
      } else if (!timeLabel) {
        timeLabel = datetimeStr;
      }
    }
    var variantTitle = (variantBtn.dataset.variantTitle || '').trim();
    if (!variantTitle && variantBtn) {
      var titleEl = variantBtn.querySelector('.wb-variant-title');
      variantTitle = titleEl ? titleEl.textContent.trim() : '';
    }
    var variantId = (variantBtn.dataset.variantId || variantBtn.getAttribute('data-variant-id') || '').trim();
    if (!variantId) {
      var hid = document.getElementById('workshop-variant');
      if (hid && hid.value) variantId = hid.value;
    }

    var displayDate = dateLabel || '—';
    if (typeof window.matchMedia !== 'undefined' && window.matchMedia('(max-width: 768px)').matches) {
      if (dateKey) {
        displayDate = formatDateForBar(dateKey);
      } else if (dateLabel && (isWeekdayOnly(dateLabel) || /^(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday)\s*[•·]\s*/.test(dateLabel))) {
        var isoPart = dateLabel.split(/\s*[•·]\s*/)[1];
        if (isoPart && /^\d{4}-\d{2}-\d{2}/.test(isoPart)) {
          displayDate = formatDateForBar(isoPart.trim().slice(0, 10));
        }
      }
    }

    return {
      venue: venue || '—',
      dateLabel: displayDate,
      timeLabel: timeLabel || '—',
      variantTitle: variantTitle || '—',
      variantId: variantId || ''
    };
  }

  function isComplete() {
    var booking = getBookingRoot();
    if (!booking) return false;
    var card = booking.querySelector('.workshop-event-card.is-selected');
    var variantBtn = booking.querySelector('.wb-variant-btn.is-active');
    return !!(card && variantBtn);
  }

  function applyBottomOffset(bar) {
    if (!bar) return;
    var v = (bar.getAttribute('data-bottom-offset') || BOTTOM_OFFSET_CSS).trim();
    if (/^\d+$/.test(v)) v = v + 'px';
    bar.style.bottom = v;
  }

  function updateBarContent(bar, data) {
    if (!bar || !data) return;

    var variantEl = bar.querySelector('[data-wb-inline-variant]');
    if (variantEl) variantEl.textContent = data.variantTitle;

    var venueEl = bar.querySelector('[data-wb-inline-venue]');
    var dateEl = bar.querySelector('[data-wb-inline-date]');
    var timeEl = bar.querySelector('[data-wb-inline-time]');
    if (venueEl) venueEl.textContent = data.venue;
    if (dateEl) dateEl.textContent = data.dateLabel;
    if (timeEl) timeEl.textContent = data.timeLabel;

    var thumbWrap = bar.querySelector('[data-wb-inline-thumb-wrap]');
    var thumbImg = bar.querySelector('[data-wb-inline-thumb]');
    if (thumbWrap && thumbImg) {
      var src = data.variantId ? getVariantImageUrl(data.variantId) : '';
      if (src) {
        thumbImg.src = src;
        thumbImg.alt = data.variantTitle && data.variantTitle !== '—' ? data.variantTitle : 'Variant';
        thumbWrap.removeAttribute('hidden');
      } else {
        thumbImg.src = '';
        thumbImg.alt = '';
        thumbWrap.setAttribute('hidden', '');
      }
    }
  }

  function setBarVisible(bar, visible, dockAboveFooter) {
    if (!bar) return;
    bar.classList.toggle('is-visible', visible);
    bar.classList.toggle('is-below-panel', !!dockAboveFooter);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if (visible) {
      bar.removeAttribute('hidden');
    } else {
      bar.setAttribute('hidden', '');
    }
  }

  function scrollToPanelAndOpen() {
    var panel = getPanel();
    var bookingBox = getBookingBox();
    if (panel) {
      panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (typeof window.wbOpenStickyPanel === 'function') {
        window.wbOpenStickyPanel(bookingBox);
      } else {
        var root = panel.closest('[data-ai-wb-sticky]') || panel;
        var toggle = root.querySelector('[data-ai-wb-sticky-toggle]');
        if (toggle) {
          root.classList.remove('wb-panel--collapsed');
          root.classList.add('wb-panel--expanded');
          toggle.setAttribute('aria-expanded', 'true');
          var body = root.querySelector('[data-ai-wb-sticky-body]');
          if (body) body.style.maxHeight = '';
        }
      }
    }
  }

  function run() {
    var bar = getBar();
    if (!bar) return;

    applyBottomOffset(bar);

    var panelInView = false;
    var venueCardPanelInView = false;
    var footerInView = false;
    var footerRect = null;

    function updateVisibility() {
      var show = isComplete() && !panelInView && !venueCardPanelInView;
      var dockAboveFooter = show && footerInView && footerRect;

      if (dockAboveFooter && footerRect) {
        var gap = 12;
        bar.style.bottom = (window.innerHeight - footerRect.top + gap) + 'px';
      } else {
        applyBottomOffset(bar);
      }

      setBarVisible(bar, show, dockAboveFooter);
    }

    function refreshContent() {
      if (!isComplete()) return;
      var data = readSelection();
      if (data) updateBarContent(bar, data);
    }

    var panel = getPanel();
    var venueCardPanel = getVenueCardPanel();
    var footer = getFooter();

    if (panel) {
      var panelObs = new IntersectionObserver(
        function (entries) {
          panelInView = entries[0].isIntersecting;
          updateVisibility();
        },
        { root: null, rootMargin: '0px', threshold: 0.1 }
      );
      panelObs.observe(panel);
    }

    if (venueCardPanel) {
      var venueCardObs = new IntersectionObserver(
        function (entries) {
          venueCardPanelInView = entries[0].isIntersecting;
          updateVisibility();
        },
        { root: null, rootMargin: '0px', threshold: 0.1 }
      );
      venueCardObs.observe(venueCardPanel);
    }

    if (footer) {
      var footerObs = new IntersectionObserver(
        function (entries) {
          footerInView = entries[0].isIntersecting;
          footerRect = footerInView ? footer.getBoundingClientRect() : null;
          updateVisibility();
        },
        { root: null, rootMargin: '0px', threshold: 0 }
      );
      footerObs.observe(footer);
    }

    var editBtn = bar.querySelector('[data-wb-inline-summary-edit]');
    if (editBtn) {
      editBtn.addEventListener('click', function () {
        scrollToPanelAndOpen();
      });
    }

    var poll = setInterval(function () {
      if (!getBookingRoot() || !getBar()) {
        clearInterval(poll);
        return;
      }
      refreshContent();
      updateVisibility();
    }, POLL_MS);

    refreshContent();
    updateVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
